// to.js
export function to (promise) {
    return promise
        .then(data => {
            return [null, data];
        })
        .catch(err => [err]);
}